const defaultComponents = {
    block: {
        normal: ({children}) => <div className="text-block">{children}</div>,
        h1: ({children}) => <h1>{children}</h1>,
        h2: ({children}) => <h2>{children}</h2>,
        h3: ({children}) => <h3>{children}</h3>,
        h4: ({children}) => <h4>{children}</h4>,
        h5: ({children}) => <h5>{children}</h5>,
        h6: ({children}) => <h6>{children}</h6>
    },
    types: {
        span: ({value}) => <span>{value.text}</span>
    },
    marks: {
        strong: ({children}) => <strong>{children}</strong>,
        em: ({children}) => <em>{children}</em>,
        small: ({ children }) => <span style={{ fontSize: '0.8em' }}>{children}</span>,  // Makes text 80% of normal size
        smaller: ({ children }) => <span style={{ fontSize: '0.6em' }}>{children}</span>,  // Even smaller
    }
};

export default defaultComponents;